import React from 'react';
import {
    Box,
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@material-ui/core';

const toNumberOrNull = (value) => {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : null;
};

// 1. Tabla de Percentiles para las Dimensiones
const getDimensionPercentile = (stdScore) => {
    const s = Number(stdScore);
    if (s >= 20) return '>99';
    if (s === 19) return '>99';
    if (s === 18) return '>99';
    if (s === 17) return '99';
    if (s === 16) return '98';
    if (s === 15) return '95';
    if (s === 14) return '91';
    if (s === 13) return '84';
    if (s === 12) return '75';
    if (s === 11) return '63';
    if (s === 10) return '50';
    if (s === 9) return '37';
    if (s === 8) return '25';
    if (s === 7) return '16';
    if (s === 6) return '9';
    if (s === 5) return '5';
    if (s === 4) return '2';
    if (s === 3) return '1';
    if (s <= 2) return '<1';
    return '-';
};

// 2. Tabla para el Índice de Calidad de Vida (ICV) y su Percentil
const QOL_INDEX_TABLE = {
    109: [123, 94], 108: [122, 93], 107: [122, 92], 106: [121, 92], 105: [120, 91],
    104: [119, 90], 103: [118, 89], 102: [118, 88], 101: [117, 87], 100: [116, 86],
    99: [115, 84], 98: [114, 83], 97: [114, 82], 96: [113, 80], 95: [112, 79],
    94: [111, 77], 93: [110, 76], 92: [110, 74], 91: [109, 72], 90: [108, 70],
    89: [107, 68], 88: [106, 66], 87: [106, 65], 86: [105, 63], 85: [104, 60],
    84: [103, 58], 83: [102, 56], 82: [102, 54], 81: [101, 52], 80: [100, 50],
    79: [99, 48], 78: [98, 46], 77: [98, 44], 76: [97, 42], 75: [96, 40],
    74: [95, 37], 73: [94, 35], 72: [94, 34], 71: [93, 32], 70: [92, 30],
    69: [91, 28], 68: [90, 26], 67: [90, 24], 66: [89, 23], 65: [88, 21],
    64: [87, 20], 63: [86, 18], 62: [86, 17], 61: [85, 16], 60: [84, 14],
    59: [83, 13], 58: [82, 12], 57: [82, 11], 56: [81, 10], 55: [80, 9],
    54: [79, 8], 53: [78, 8], 52: [78, 7], 51: [77, 6], 50: [76, 6],
    49: [75, 5], 48: [74, 4], 47: [74, 4], 46: [73, 4], 45: [72, 3],
    44: [71, 3], 43: [71, 2], 42: [70, 2], 41: [69, 2], 40: [68, 2],
    39: [67, 1], 38: [67, 1], 37: [66, 1], 36: [65, 1], 35: [64, 1],
    34: [63, 1], 33: [63, 1], 32: [62, 1]
};

const getQoLData = (totalStandardScore) => {
    if (totalStandardScore >= 109) return { index: 123, percentile: 94 };
    if (totalStandardScore <= 32) return { index: 62, percentile: 1 };
    
    const data = QOL_INDEX_TABLE[totalStandardScore];
    if (data) {
        return { index: data[0], percentile: data[1] };
    }
    return { index: '-', percentile: '-' };
};

// 3. Función de mapeo de Puntuación Directa a Estándar 
const getStandardScore = (factorCode, directScore) => {
    const score = Number(directScore);
    const table = {
        'F1': [[32, 99, 14], [30, 31, 13], [27, 29, 12], [25, 26, 11], [23, 24, 10], [21, 22, 9], [19, 20, 8], [16, 18, 7], [14, 15, 6], [12, 13, 5], [10, 11, 4], [8, 9, 3]],
        'F2': [[23, 99, 13], [21, 22, 12], [20, 20, 11], [18, 19, 10], [16, 17, 9], [14, 15, 8], [13, 13, 7], [11, 12, 6], [9, 10, 5], [8, 8, 4], [6, 7, 3]],
        'F3': [[28, 99, 12], [27, 27, 11], [25, 26, 10], [24, 24, 9], [23, 23, 8], [22, 22, 7], [21, 21, 6], [20, 20, 5], [18, 19, 4], [17, 17, 3], [16, 16, 2], [7, 15, 1]],
        'F4': [[32, 99, 15], [30, 31, 14], [27, 29, 13], [25, 26, 12], [22, 24, 11], [20, 21, 10], [17, 19, 9], [15, 16, 8], [12, 14, 7], [10, 11, 6], [8, 9, 5]],
        'F5': [[24, 99, 14], [22, 23, 13], [21, 21, 12], [19, 20, 11], [18, 18, 10], [16, 17, 9], [15, 15, 8], [13, 14, 7], [12, 12, 6], [10, 11, 5], [9, 9, 4], [6, 8, 3]],
        'F6': [[31, 99, 15], [29, 30, 14], [26, 28, 13], [23, 25, 12], [21, 22, 11], [18, 20, 10], [16, 17, 9], [13, 15, 8], [10, 12, 7], [8, 9, 6]],
        'F7': [[36, 99, 15], [34, 35, 14], [31, 33, 13], [29, 30, 12], [26, 28, 11], [24, 25, 10], [22, 23, 9], [19, 21, 8], [17, 18, 7], [14, 16, 6], [13, 13, 5], [9, 12, 4]],
        'F8': [[20, 99, 14], [18, 19, 13], [17, 17, 12], [15, 16, 11], [13, 14, 10], [12, 12, 9], [10, 11, 8], [9, 9, 7], [7, 8, 6], [6, 6, 5], [5, 5, 4]]
    };

    const ranges = table[factorCode];
    if (!ranges) return 1;
    const match = ranges.find(r => score >= r[0] && score <= r[1]);
    if (!match && score > ranges[0][0]) return ranges[0][2];
    return match ? match[2] : 1; 
};

const computeFumatScores = (register, scale) => {
    if (!register || !scale) return null;
    const questions = Array.isArray(scale?.questions) ? scale.questions : [];
    const factors = Array.isArray(scale?.factors) ? scale.factors : [];
    const responses = Array.isArray(register?.scaleResponses) ? register.scaleResponses : [];
    if (!questions.length || !responses.length) return null;

    const factorMap = new Map();
    factors.forEach(f => factorMap.set(f.id, f));

    const factorScores = new Map();
    const getFactorEntry = (factorId) => {
        const key = factorId ?? 'none';
        if (!factorScores.has(key)) {
            const factor = factorMap.get(factorId);
            factorScores.set(key, {
                id: factor?.id ?? key,
                code: factor?.code ?? (factorId ? `F${factorId}` : 'F'),
                label: factor?.name ?? 'Dimension',
                score: 0, 
            });
        }
        return factorScores.get(key);
    };

    const questionById = new Map(questions.map(q => [q.id, q]));

    responses.forEach(resp => {
        const q = questionById.get(resp.scaleQuestionId);
        if (!q) return;
        const options = q.questionOptionScores || [];
        const opt = options.find(o => {
            const sid = o.scaleOptionId || o.scaleOption?.id || o.id;
            return Number(sid) === Number(resp.scaleOptionId);
        });

        let optScore = toNumberOrNull(opt?.score ?? resp.score);
        if (optScore == null) return;

        const dim = getFactorEntry(q.scaleFactorId);
        dim.score += optScore;
    });

    const finalDimensions = Array.from(factorScores.values()).map(dim => {
        const standardScore = getStandardScore(dim.code, dim.score);
        const percentile = getDimensionPercentile(standardScore);
        return {
            ...dim,
            directScore: dim.score, 
            score: standardScore,
            percentile: percentile
        };
    });

    const totalStandardScore = finalDimensions.reduce((sum, d) => sum + d.score, 0);
    const qolData = getQoLData(totalStandardScore);

    return {
        totalScore: totalStandardScore,
        qolIndex: qolData.index,        
        qolPercentile: qolData.percentile, 
        dimensions: finalDimensions,
    };
};

export const ScaleResultFUMAT = ({
    title = 'Resultados',
    totalScore,
    dimensions = [],
    onComputedResult,
    register,
    scale,
}) => {
    const derived = React.useMemo(() => computeFumatScores(register, scale), [register, scale]);

    React.useEffect(() => {
        if (derived && typeof onComputedResult === 'function') {
            onComputedResult(derived); 
        }
    }, [derived, onComputedResult]);

    const displayData = derived || { 
        dimensions: dimensions, 
        totalScore: totalScore, 
        qolIndex: '-', 
        qolPercentile: '-' 
    };

    return (
        <Paper elevation={0} style={{ padding: 24, borderRadius: 12 }}>
            <Typography variant="h5" style={{ fontWeight: 700, marginBottom: 24, color: '#0d1b2a' }}>
                {title}
            </Typography>

            <TableContainer component={Paper} variant="outlined">
                <Table aria-label="fumat results table">
                    <TableHead style={{ backgroundColor: '#f4f4f4' }}>
                        <TableRow>
                            <TableCell style={{ fontWeight: 'bold' }}>Dimensiones de calidad de vida</TableCell>
                            <TableCell align="center" style={{ fontWeight: 'bold' }}>Puntuaciones directas totales</TableCell>
                            <TableCell align="center" style={{ fontWeight: 'bold' }}>Puntuaciones estándar</TableCell>
                            <TableCell align="center" style={{ fontWeight: 'bold' }}>Percentiles de las dimensiones</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {displayData.dimensions.map((dim) => (
                            <TableRow key={dim.id}>
                                <TableCell component="th" scope="row">
                                    {dim.label}
                                </TableCell>
                                <TableCell align="center" style={{ backgroundColor: '#fff0f5' }}>{dim.directScore}</TableCell>
                                <TableCell align="center" style={{ backgroundColor: '#fff0f5' }}>{dim.score}</TableCell>
                                <TableCell align="center" style={{ backgroundColor: '#fff0f5' }}>{dim.percentile || '-'}</TableCell>
                            </TableRow>
                        ))}

                        <TableRow>
                            <TableCell colSpan={2} rowSpan={3} />
                            <TableCell align="center" style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0' }}>
                                Puntuación Estándar Total (suma)
                            </TableCell>
                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
                                    {displayData.totalScore}
                                </Typography>
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell align="center" style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0', color: '#800080' }}>
                                ÍNDICE DE CALIDAD DE VIDA
                            </TableCell>
                            <TableCell align="center" style={{ fontWeight: 'bold', color: '#800080' }}>
                                <Typography variant="h6" style={{ fontWeight: 700 }}>
                                    {displayData.qolIndex}
                                </Typography>
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell align="center" style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0' }}>
                                Percentil del Índice de CV
                            </TableCell>
                            <TableCell align="center" style={{ fontWeight: 'bold', backgroundColor: '#e6e6fa' }}>
                                <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
                                    {displayData.qolPercentile}
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            {!displayData.dimensions.length && (
                <Box px={1} mt={2}>
                    <Typography variant="body2" style={{ color: '#5f6b7a' }}>
                        No hay datos suficientes para calcular los resultados.
                    </Typography>
                </Box>
            )}
        </Paper>
    );
};

export default ScaleResultFUMAT;